import React, { useState, useEffect } from 'react';
import styles, { mainCls } from './styles';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName/index';
import Grid from '../../Grid';
import GridItem from '../../GridItem';
import { Icon } from 'shared-vectors';
import CloseL from 'shared-vectors/icons/CloseL';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import SingleQRCodeLoader from '../SingleQRCodeLoader';

const useStyles = createStyle(styles);

const CallAgencyTooltipContainer = ({ 
  clsPositionToolip = '', 
  visible: showTooltip, 
  phone: phoneToConfig, 
  setTooltipVisible: setShowTooltip,
  showDynamicComponent,
  createQRCodeOnly,
  serverUri,
  listingId,
}) => {
  const cls = useStyles();
  const phone = phoneToConfig && phoneToConfig.indexOf('+') === 0
  ? phoneToConfig
  : `+39${phoneToConfig}`;
  
  // If listingId is present, the QR code will be generated with the listingId 
  // otherwise it will be generated with the phone number
  // just to track qrcode usage
  const baseQrCodeUri = listingId && `${serverUri}/chiama/immobile/${listingId}/`;
  const linkQRcode = baseQrCodeUri || `tel:${phone}`;

  const [isVisibleHint, setIsVisibleHint] = useState(false);
  const hideTooltip = ({ position }) => { 
    setShowTooltip(false, position);
  };

  const toolTipCls = makeClassName([
    cls[`${mainCls}`],
    clsPositionToolip && cls[`${mainCls}${clsPositionToolip}`],
    showTooltip && cls[`${mainCls}__visible`],
  ]);
  const handleClickOutside = (event) => {
    if (showTooltip && !event.target.closest(`.${mainCls}`)) {
      hideTooltip({ position: 'ExternalClick'});
    }
  };

  useEffect(() => {
    let clickHandlerTimeout;
  
    if (showTooltip) {
      clickHandlerTimeout = setTimeout(() => {
        window.addEventListener('click', handleClickOutside);
      }, 0);
    }
  
    return () => {
      clearTimeout(clickHandlerTimeout);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [showTooltip]);

  const expand = () => {
    setIsVisibleHint(true);
    trackGTMEvents({
      action: 'ShowHowItWorksPhoneQR',
      category: 'SwitchToMobile',
    });
  }

  return (
    <Grid className={toolTipCls} noWrap direction="column" align="end">
       <Grid className={`${cls[`${mainCls}__header`]} ml--s mb--s`} onClick={() => hideTooltip({ position: 'CloseButton'})}>
          <Icon className={`${cls[mainCls]}__header_close`}
            name={CloseL} 
            size="m" 
            color="red"
            width="14px" 
            height="14px"
          />
      </Grid>
      <Grid noWrap>
        <GridItem className={`${cls[`${mainCls}__left_cnt`]}`}>
          <span className="tp-w--s tp-s--s c-txt--f0 tp-a--l mb--xs">
            <p className='tp-w--l tp-s--l mb--xs c-txt--f0'>Chiama dal tuo cellulare</p> inquadrando il codice QR
          </span>
          <Grid noWrap className={`${cls[`${mainCls}__how_works`]} ${isVisibleHint ? 'disabled ' : ''}`}>
            <p className={`${cls[`${mainCls}__info`]} mr--xs c-txt--f0 tp-a--l`}>i</p>
            <p onClick={expand}className={`${isVisibleHint ? '' : 'tp--u '}tp-w--s tp-s--x2s c-txt--f0 tp-a--l`}>Come funziona?</p>
          </Grid>
        </GridItem>
        <GridItem className="ml--s" behavior="fixed">

        <SingleQRCodeLoader
          value={linkQRcode}
          showDynamicComponent={showDynamicComponent}
          createQRCodeOnly={createQRCodeOnly}
          type='svg'
        />
        </GridItem>
      </Grid>
      <Grid>
      {isVisibleHint && (
        <GridItem className={`${cls[`${mainCls}__expanded-txt`]} mt--s tp-w--s tp-s--s c-txt--f0 tp-a--l`}  >
          <p>
            Se inquadri il codice, il tuo telefono lo riconoscerà come numero e 
            potrai far partire direttamente la chiamata.
          </p>
        </GridItem>
      )}
      </Grid>
    </Grid>
  );
};

export default CallAgencyTooltipContainer;
